export function ScoreGauge({ score, scale = 850, label, tier, size = 168, testId = "score-gauge" }) {
  const radius = (size - 22) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(1, score / scale));
  const offset = circumference * (1 - pct);
  const color = pct >= 0.8 ? "#1a5fd0" : pct >= 0.6 ? "#0284c7" : "#e11d48";
  const center = size / 2;
  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testId} style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={center} cy={center} r={radius} fill="none" stroke="#e2e8f0" strokeWidth="11" />
        <circle
          cx={center} cy={center} r={radius} fill="none" stroke={color} strokeWidth="11"
          strokeLinecap="round" strokeDasharray={circumference}
          className="ring-anim"
          style={{ "--ring-start": circumference, "--ring-end": offset, strokeDashoffset: offset }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-head text-4xl font-extrabold text-slate-900 tabular-nums">{score}</div>
        <div className="font-mono text-[10px] text-slate-400">/ {scale}</div>
        {tier && <div className="mt-1 text-[11px] font-semibold" style={{ color }}>{tier}</div>}
        {label && <div className="text-[10px] uppercase tracking-wider text-slate-400">{label}</div>}
      </div>
    </div>
  );
}
